<template>
<div>
    <router-link :to="'/stores/'+row.store_id+'/products/details/'+row.id" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
	    <i class="fa fa-eye"></i>
    </router-link>
    <router-link :to="'/stores/'+row.store_id+'/products/update/'+row.id" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
	    <i class="fa fa-edit"></i>
    </router-link>
    <router-link :to="'/stores/'+row.store_id+'/products/tag/'+row.id" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
        <i class="fa fa-tag"></i>
    </router-link>
    <router-link :to="'/stores/'+row.store_id+'/products/discount/'+row.id" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
        <i class="fa fa-percentage"></i>
    </router-link>
</div>
</template>

<script>
import $ from 'jquery'
import Vue from 'vue'

export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
})
</script>

<style>

</style>